import apiClient from "./client";
import type {
  GetLatestStocksParams,
  LatestStocksResponse,
} from "../types/disaster";

export const getLatestStocks = async (
  params: GetLatestStocksParams
): Promise<LatestStocksResponse> => {
  const { data } = await apiClient.get<LatestStocksResponse>("/latest-stocks", {
    params: {
      site_id: params.site_id,
      order: params.order,
      sort: params.sort,
      page: params.page,
      limit: params.limit,
    },
  });
  return data;
};
